export default {
  'zh-CN': {
    nav: {
      home: '首页',
      about: '关于湘楚',
      products: '产品服务',
      news: '新闻资讯',
      jobs: '人才招聘',
      party: '党建园区',
      overseas: '海外专栏'
    },
    lang: {
      switchToEn: 'English',
      switchToZh: '中文'
    },
    header: {
      aboutMenu: {
        title: '关于湘楚',
        desc: '湘楚人力资源集团有限公司，成立于2003年，经过22年的奋力拼搏，目前已与数十个行业的数百家单位建立了业务合作关系，每年服务员工人数达50000余人，为客户单位规范、和谐劳动关系，降低用工成本、提高员工技能、增加用工灵活性等提供了强有力的保障。',
        intro: '企业简介',
        honor: '荣誉资质',
        team: '管理团队',
        culture: '企业文化',
        contact: '联系我们'
      }
    },
    newHome: {
      tools: {
        homeShort: '湘'
      }
    },
    heroBanner: {
      title: '梦筑湘楚',
      slogan: '梦初始 匠心筑 湖湘魂 楚天阔'
    },
    companyIntro: {
      title: '公司介绍',
      desc1:
        '湘楚人力资源集团有限公司成立于2003年，经过22年的奋力拼搏，已与数十个行业的数百家单位建立业务合作关系。',
      desc2:
        '每年服务员工人数达50000余人，为客户单位规范、和谐劳动关系，降低用工成本，提高员工技能，增加用工灵活性提供有力保障。',
      stats: {
        ip: '知识产权',
        branches: '分子公司',
        clients: '合作客户',
        employees: '服务员工'
      }
    },
    aboutIntro: {
      title: '企业简介',
      subTitle: 'SYNOPSIS',
      desc1: '湘楚人力资源集团是湖南省内最早成立的综合性服务人力资源企业。集团创始于2003年，截至2025年，湘楚集团覆盖全国已超50家分支机构，服务客户超800家，服务员工人数超30万，已成为国内知名的专业人力资源综合服务提供商。',
      desc2: '我们专注于服务人才治理及全景数字人力研发；依托辐射全国的实体服务网络、先进的SaaS产业服务平台，为客户提供涵盖企业咨询管理外包、人才猎聘、人力资源项目外包及风险保障方案等在内的一站式解决方案。'
    },
    aboutHero: {
      title: '关于湘楚',
      subtitle: 'ABOUT XIANGCHU',
      breadcrumbHome: '首页',
      breadcrumbCurrent: '关于湘楚',
      anchorIntro: '企业简介',
      anchorHonor: '荣誉资质',
      anchorCulture: '企业文化',
      anchorTeam: '管理团队'
    },
    milestoneSection: {
      milestones: {
        '2024': {
          desc: ['湖南省人力资源服务促进就业成效明显机构', '湖南省上市后备企业资源库', '长沙天心经开区诚信经营企业', '湘潭市两新领域示范性红色党建品牌']
        },
        '2023': {
          desc: ['全国第三批百家金牌劳动人事争议调解组织', '长沙市人力资源服务重点企业促进就业示范机构', 'HRoot 2022年度最佳人力资源服务机构', '2022年度湖南省人力资源服务高质量发展企业']
        },
        '2022': {
          desc: ['湘潭市红色党建品牌示范单位', '湖南省创业带动就业人力资源服务示范机构', '湖南省劳动人事争议金牌调解组织', '获评湖南省服务业数字基建重点项目']
        },
        '2020': {
          desc: ['获得“AAA企业信用等级证书”', '新增贵州、宁夏等多家分公司，服务网络持续扩大']
        },
        '2019': {
          desc: ['获得“湘潭市年度建筑劳务10强企业”荣誉称号', '获得“A级（优秀）单位”荣誉称号']
        },
        '2018': {
          desc: ['成立湘楚人力资源集团有限公司', '全新战略布局，开启品牌时代新篇章']
        },
        '2017': {
          desc: ['成立湖南湘楚人力资源有限公司校园分公司']
        },
        '2016': {
          desc: ['获得首届中国清洁文化节企业文化银奖', '成立邵阳、永州等多家分公司']
        },
        '2015': {
          desc: ['更名为湖南湘楚人力资源有限公司', '成立娄底分公司、长沙分公司']
        },
        '2014': {
          desc: ['获得中国清洁清洗行业等级资质国家一级资质']
        },
        '2012': {
          desc: ['获得“著名劳务派遣品牌机构”荣誉称号', '成立湘潭市人力资源培训学校']
        },
        '2011': {
          desc: ['生产外包服务项目正式启动，产品全面升级', '成立湖南湘楚环境物业管理有限公司']
        },
        '2009': {
          desc: ['业务发展初具规模，服务外派雇员逾万人', '成立湖南湘人网络通信有限公司']
        },
        '2007': {
          desc: ['获得“劳动保障诚信企业”荣誉称号', '引入核心管理层，组建精英团队']
        },
        '2006': {
          desc: ['服务网络全面覆盖湘潭市范围，并辐射至长沙、株洲']
        },
        '2005': {
          desc: ['获得“再就业先进企业”荣誉称号']
        },
        '2003': {
          desc: ['湘潭市人力资源服务有限公司成立', '成立湖南湘楚人力资源有限公司']
        }
      }
    },
    honorSection: {
      title: '荣誉资质',
      subTitle: 'HONOR',
      tabHonor: '企业荣誉',
      tabCert: '资质证书',
      honor1: '五星党组织',
      honor2: '国家高新技术企业',
      honor3: '常务理事单位',
      honor4: '劳动保障守法诚信A级单位',
      honor5: '四新经济示范企业',
      honor6: '最佳人力资源服务机构',
      cert1: '劳务派遣经营许可证',
      cert2: '人力资源服务许可证',
      cert3: '安全生产许可证',
      cert4: '信息安全管理体系认证',
      cert5: '质量服务诚信单位',
      cert6: '企业资信等级AAA'
    },
    teamSection: {
      title: '管理团队',
      subTitle: 'TEAM',
      members: {
        m1: { name: '丁春松', position: '中共党员、工程师、高级人力资源师、高级经济师', desc: '☞ 现任湘楚人力资源集团党委书记，董事长兼总裁。<br/>☞ 曾有从政府机关到国企领导再到民企创业的独特经历，从事企业人力资源管理20年。' },
        m2: { name: '李双双', position: '湘楚人力党委委员、湘楚人力资源集团有限公司副总裁', desc: '☞ 中共党员、会计师。<br/>☞ 擅长股权激励、控制权配置、资本路径规划等系统性解决方案。' },
        m3: { name: '严寒', position: '湘楚人力党委委员、湘楚人力资源集团有限公司副总裁', desc: '☞ 高级人力资源管理师、国际注册会计师ICPA。<br/>☞ 人社领域专家库成员。' },
        m4: { name: '马瑛', position: '湘楚人力党委委员、湘楚人力资源集团有限公司副总裁', desc: '☞ 高级人力资源管理师，信息化管理专家。<br/>☞ 负责行业SAAS、HRO综合服务平台产品研发及项目运营。' },
        m5: { name: '楚雅琼', position: '湘楚人力党委委员、湘楚人力资源集团有限公司副总裁', desc: '☞ 国家一级劳动关系协调员。<br/>☞ 具有劳动关系管理丰富经验。' },
        m6: { name: '熊国平', position: '湘楚人力党委副书记、工会主席', desc: '☞ 具有多年从事安全生产及相关行业工作经历。<br/>☞ 掌握安全生产法律法规与技术标准，实践经验丰富。' },
        m7: { name: '蒋群', position: '湘楚人力党委委员、湘潭市人力资源培训学校校长', desc: '☞ 从事人力资源行业近10年，具有丰富行业经验。<br/>☞ 曾参与多项人力资源规范管理与绩效体系建设。' },
        m8: { name: '朱爱平', position: '湘楚人力资源集团营销部总监', desc: '☞ 擅长市场营销、客户服务、劳务派遣等业务。<br/>☞ 具有丰富的市场营销和企业管理经验。' },
        m9: { name: '黄根荣', position: '湖南湘楚人力资源研究院有限公司特聘专家', desc: '☞ 高级经济师、高级政工师。<br/>☞ 具有36年人力资源管理与咨询经历。' },
        m10: { name: '沈娅萍', position: '湘楚人力资源集团法律顾问', desc: '☞ 从业32年，审核过上万件合同。<br/>☞ 处理法律咨询量过万起。' }
      }
    },
    presidentMessage: {
      title: '总裁寄语',
      subTitle: 'MESSAGE',
      slogan: '以“业务遍及全国，服务触达世界，成为国内位居前列的一站式人力资源整体解决方案服务提供商”为企业愿景',
      p1: '历史于时序更替中前行，梦想在砥砺奋进中实现。二十二载风雨淬炼，是不变的坚守和信念；二十二载砥砺前行，是勤力同心共谱新篇。',
      p2: '湘楚人力的每一点成长，都离不开每一位湘楚人的辛勤和付出，也离不开社会各界人士的关心和帮助、行业专家的鼓励与鞭策，以及广大客户的信赖与支持。',
      p3: '着眼全局，展望未来，湘楚人力将迎来更加光明的发展前景，在新时代继续谱写“惟楚有材、于斯为盛”的崭新篇章。'
    },
    serviceSection: {
      menu1Text1: '人力资源+',
      menu1Text2: '劳动关系服务',
      menu1Desc: '降低人力成本，实现效率最大化',
      menu2Text1: '人力资源+',
      menu2Text2: '人才服务',
      menu2Desc: '提升企业整体素质，创造持续的核心竞争力',
      menu3Text1: '人力资源+',
      menu3Text2: '管理咨询服务',
      menu3Desc: '提供优质服务，提升企业和管控水平',
      menu4Text1: '人力资源+',
      menu4Text2: '数智云服务',
      menu4Desc: '助力中小企业实现互联网+下的管理变革',
      g0c0Title: '劳务外包',
      g0c0Desc: '劳务外包，可帮助公司负责托管人员相关事务，并提供有关劳动方面咨询。',
      g0c1Title: '劳务派遣',
      g0c1Desc: '劳务派遣由具备资质机构向用工单位派遣人员，满足弹性用工需求。',
      g0c2Title: '灵活用工体系',
      g0c2Desc: '满足企业 1 天、1 月、1 年等不同周期用工场景需求。',
      g1c0Title: '人才招聘',
      g1c0Desc: '企业可将招聘需求外包给湘楚，提升招聘效率与到岗速度。',
      g1c1Title: '人才测评',
      g1c1Desc: '通过心理测验、情境模拟等客观方法，提升岗位匹配准确率。',
      g1c2Title: '数字化档案管理',
      g1c2Desc: '解决档案存储空间与效率问题，实现标准化、规范化档案管理。',
      g2c0Title: '人力资源规划',
      g2c0Desc: '将规划转化为人力管理需求，提升人力资源工作的前瞻性与系统性。',
      g2c1Title: '战略规划咨询',
      g2c1Desc: '帮助企业识别内外部环境，明确战略定位与实施路径。',
      g2c2Title: '产智融三结合创新赋能平台',
      g2c2Desc: '理顺集团与分子公司职责分工，提升组织协同效率。',
      g3c0Title: '数智云服务',
      g3c0Desc: '搭建数字化人力资源系统，提升效率，实现业务在线一站式办理。'
    },
    enterpriseStrength: {
      mainTitle: 'STRENGTH',
      subTitle: '企业实力',
      tabCities: '业务覆盖城市',
      tabBranches: '子、分公司',
      c1Title: '湖南湘楚人力资源有限公司',
      c1Desc: '成立于2003年，是湘楚人力集团最早设立的全资子公司之一，主要服务于湖南省域客户。',
      c2Title: '湖南湘楚人力资源研究院',
      c2Desc: '湖南省唯一一家冠以“研究院”为名的人力资源研究机构，持续提供专业研究支持。',
      c3Title: '湖南叮点信息科技有限公司',
      c3Desc: '成立于2018年，专注中小企业数智化转型，致力于提供咨询与设计服务。',
      c4Title: '湖南湘楚环境物业管理有限公司',
      c4Desc: '成立于2011年，提供道路清扫保洁、园林绿化维护、公共物业管理等综合服务。',
      c5Title: '湖南湘楚物流有限公司',
      c5Desc: '成立于2016年，以人力资源服务为核心，覆盖劳务外包与管理咨询等业务。',
      c6Title: '湖南湘人工程有限公司',
      c6Desc: '成立于2009年，拥有成熟工程服务能力，长期服务于省内外多个行业客户。',
      c7Title: '湘潭市人力资源培训学校',
      c7Desc: '拥有多项职业技能培训资质以及特种作业培训资质，持续输出实用型人才。',
      c8Title: '湘乡市人力资源服务有限公司',
      c8Desc: '创办于2005年，秉承“为人才创造机会，为企业发掘资源”的服务理念。',
      c9Title: '长沙禾米创意文化传播有限公司',
      c9Desc: '汇聚品牌策划、创意设计、公关咨询及网络营销团队，提供品牌整合服务。',
      c10Title: '湖南值了科技有限公司',
      c10Desc: '成立于2022年，获集团种子轮投资，持续探索创新型企业服务产品。',
      c11Title: '湖南湘楚晟和企业咨询服务有限公司',
      c11Desc: '专注企服领域，作为集团全资子公司之一，打造全生态链服务能力。',
      c12Title: '湖南湘楚优护健康管理有限公司',
      c12Desc: '一站式智慧陪护服务商，覆盖医院陪诊、居家照护、家庭照护等专业场景。'
    },
    cooperation: {
      mainTitle: 'COOPERATION',
      subTitle: '合作品牌',
      content:
        '湘楚人力提供全面、专业的服务，帮助客户把非核心岗位或业务流程分离出去，通过专业的人员管理以及规范化的操作流程，简化客户的用工程序，减少人员管理的成本；以先进的IT技术和系统支持，降低企业的用工风险、提升企业管理效率，让客户从繁琐的事务性工作中解脱出来，将精力投入到更有价值的核心业务中。'
    },
    qysm: {
      item1Title: '企业使命：',
      item1Slogan: '助力企业成功，服务员工升值',
      item2Title: '企业愿景：',
      item2Slogan: '业务遍及全国，服务触达世界；成为国内位居前列的一站式人力资本整体解决方案服务提供商',
      item3Title: '企业行为准则：',
      item3Slogan: '客户为上、品质第一、诚信守法、成人达己',
      item4Title: '员工行为准则：',
      item4Slogan: '携手合作，创造价值',
      item5Title: '企业经营理念：',
      item5Slogan: '让服务的价值觉得到、算的出、看得见',
      cultureAlt: '企业文化'
    },
    culture: {
      title: '企业文化',
      missionTitle: '使命',
      missionDesc: '助力企业成功，服务员工升值',
      visionTitle: '愿景',
      visionDesc: '业务遍及全国，服务触达世界；成为国内位居前列的一站式人力资本整体解决方案服务提供商',
      codeTitle: '企业行为准则',
      codeDesc: '客户为上、品质第一、诚信守法、成人达己',
      staffCodeTitle: '员工行为准则',
      staffCodeDesc: '携手合作，创造价值',
      philosophyTitle: '企业经营理念',
      philosophyDesc: '让服务的价值觉得到、算得出、看得见'
    },
    contactUs: {
      heroTitle: '联系我们',
      heroSubtitle: 'CONTACT US',
      breadcrumbHome: '首页',
      breadcrumbCurrent: '联系我们',
      anchorMap: '湘楚地图',
      anchorCompany: '子分公司',
      anchorMessage: '在线留言',
      poetry1: '一土一木一开拓，一吟一颂一山河',
      poetry2: '多年耕耘与付出',
      poetry3: '迎来一片繁花似锦',
      manager: '主负责人：',
      phone: '联系电话：',
      mapTitle: '湘楚地图',
      companies: {
        c1Name: '湖南湘楚人力资源有限公司',
        c1Desc: '创立于2003年，是湘楚人力资源集团最早设立的全资子公司之一。经过多年发展，已在全省各地市建立分公司，形成一体化人力资源系统解决方案能力。与钢铁、金融、机械制造、交通通信、矿产能源、环卫清扫保洁等数十个行业合作，年服务员工人数达3万多人。',
        c2Name: '湖南湘楚人力资源研究院有限公司',
        c2Desc: '湖南湘楚人力资源研究院是湖南省冠以“研究院”名称的人力资源研究机构。研究院聚焦政策课题、组织发展、人力资源管理、企业文化、行业研究、人才测评、猎头与培训等模块，创新引入“HRmix+信息系统”理论，服务于政府单位、外资企业、民营企业及中小微企业。',
        c3Name: '湖南叮点信息科技有限公司',
        c3Desc: '成立于2018年，专注于中小企业数智化转型，提供咨询设计、技术开发、系统运营维护等一站式服务。依托集团资源，形成人力、财务、项目、安全、风险与信用等企业生态微服务能力，持续推动企业降本增效。',
        c4Name: '湖南湘楚环境物业管理有限公司',
        c4Desc: '成立于2011年，注册资本1200万元，专注道路清扫保洁、园林绿化维护、公共物业管理及水污染治理。',
        c5Name: '湖南湘楚物流有限公司',
        c5Desc: '成立于2016年，注册资金500万元。以人力资源服务为核心，主营劳务外包、物流项目申报、企业管理咨询、定制培训、物流人才输送与物流信息服务。',
        c6Name: '湖南湘人工程有限公司',
        c6Desc: '其前身为湖南湘人网络通讯有限公司，成立于2009年，注册资金800万元，具有电力工程施工总承包三级资质。',
        c7Name: '湘潭市人力资源培训学校',
        c7Desc: '学校具备计算机操作工、钳工、焊工、电工、营销师等多项职业技能培训资质及特种作业培训资质，围绕劳动者职业周期提供培训与增值服务。',
        c8Name: '湘乡市人力资源服务有限公司',
        c8Desc: '创办于2005年，秉承“为人才创造机会，为企业发掘资源，为社会创造价值”的宗旨，形成集培训、服务、管理于一体的人力资源服务能力。',
        c9Name: '长沙禾米创意文化传播有限公司',
        c9Desc: '聚焦品牌策划、创意设计、公关咨询与网络营销，围绕品牌诊断、整合、设计与推广提供系统化服务。',
        c10Name: '湖南值了科技有限公司',
        c10Desc: '成立于2022年，是聚焦大学生求职、购物、社交、创业、考培的一体化新社交平台运营主体，持续探索校园创新与创业服务。',
        c11Name: '湖南湘楚晟和企业咨询服务有限公司',
        c11Desc: '专注企服领域，提供工商服务、知识产权服务、政府资金与项目申报等全生命周期企业服务。',
        c12Name: '湖南湘楚优护健康管理有限公司',
        c12Desc: '国内优质的一站式智慧陪护服务商，提供医院陪诊、医院陪护、居家照护、长者陪伴等健康专业陪护服务。'
      }
    },
  
    siteFooter: {
      followUs: '关注我们',
      recruit: '人才招聘',
      socialRecruit: '社会招聘',
      talentPool: '湘楚人才库',
      contact: '联系我们',
      map: '湘楚地图',
      branch: '子、分公司',
      legal: '法律信息',
      agreement: '服务协议',
      privacy: '隐私政策',
      name: '姓名：',
      contactEmail: '联系方式（邮箱）：',
      demandPlaceholder: '请把您的需求留下，我们为您提供专业的解决方案',
      submit: '马上提交',
      validateName: '请输入姓名',
      validatePhone: '请输入联系方式（邮箱）',
      validateRemark: '请输入具体描述问题!',
      submitSuccess: '提交成功! 我们会在1~3个工作日内回复您。',
      submitError: '提交异常，请稍后重试'
    },
    overseasColumn: {
      hero: {
        title: '海外人力资源全周期解决方案',
        desc1: '从市场试水到持续深耕，简化海外用工流程，确保合规高效，',
        desc2: '加速海外业务成功落地',
        cta: '立即启用  定制专属方案'
      },
      common: {
        painPoints: '典型痛点',
        solution: '解决方案',
        value: '客户价值',
        learnMore: '了解更多'
      },
      scenario1: {
        title: '场景一：市场试水，快速启动',
        subtitle: '零实体落地也能合规起步',
        pain1: '组建公司慢、成本高，市场验证和试错成本高',
        pain2: '用工流程复杂繁琐，耗时又费力，常常卡在审批环节',
        solutionTitle: '名义雇主（EOR） + 专家派遣',
        solution1: '“零设点”落地：无需设立实体公司，1-4周内合规入职，财务与管理一体化完成',
        solution2: '“专家级派遣”服务：为派遣人才、跨区域外派员工提供签证、房屋、税务等全流程支持',
        value: '降低启动成本，缩短市场验证周期，规避用工风险'
      },
      scenario2: {
        title: '场景二：业务扩张，团队搭建',
        subtitle: '破解招人管薪难题',
        pain1: '本地人才供给难以跟上业务拓展，招聘周期长',
        pain2: '跨境薪酬、税务、福利等制度复杂，合规难点大',
        solutionTitle: '深度招聘（RPO） + 薪酬外包（PPO）',
        solution1: '“全渠道”招聘：依托本地化招聘网络、数字化平台与校招渠道，精准匹配岗位需求',
        solution2: '“轻运营”管薪：全流程薪酬设计、个税申报、社保缴纳、发薪与报表，保障100%合规',
        value: '突破地域用人界限，提升用工效率，实现业务团队快速扩张'
      },
      scenario3: {
        title: '场景三：项目攻坚，成建制管理',
        subtitle: '保障大规模团队稳定运行',
        pain1: '大项目通常需要数百名多国籍施工团队，涉及签证、住宿、运输、安保等各类管理挑战',
        pain2: '高流动性、高协同要求，容易因文化冲突、制度执行不均与管理不善影响项目进度',
        solutionTitle: '蓝领劳动力整体解决方案',
        solution1: '“资源前置”协同与管理：覆盖招募筛选、签证办理、入场管理、集中宿舍、运输协调、薪酬及安全合规管理',
        solution2: '“驻场管家”驻场服务：配备专业驻场团队，保障日常沟通、文化适配、应急事件处理，提升团队凝聚与稳定性',
        value: '保障人力资源持续供给，提升现场执行力，统筹跨文化组织效率与人员稳定度'
      },
      scenario4: {
        title: '场景四：持续深耕，体系化运营',
        subtitle: '系统性风险，提质增效',
        pain1: '缺乏本地劳动法合规和管理经验，存在隐性合规风险',
        pain2: '海外团队能力不足，跨文化协作困难，影响长期发展',
        solutionTitle: '人力资源咨询 + 赋能化培训',
        solution1: '“合规顾问”咨询：政策动态合规解读，员工手册定制、品牌塑造方案，并协助内部合规审查与落地',
        solution2: '“文化赋能”培训：通过跨文化沟通技巧、主管领导力提升，帮助团队建立跨境管理能力',
        value: '主动规避系统性风险，增强组织执行力与凝聚力，助力可持续发展'
      },
      cta: {
        title: '全球跨境人力资源服务，陪你从起步到深耕',
        desc: '覆盖市场试探、项目成建制、体系化运营等全阶段海外需求，适应您的目标，助力海外业务持续深耕',
        button: '立即启用  定制专属方案'
      }
    },
    laborRelations: {
      nav: {
        logoAlt: '湘楚人力资源集团',
        home: '首页',
        about: '关于湘楚',
        products: '产品服务',
        news: '新闻资讯',
        jobs: '人才招聘',
        party: '党建园区',
        en: 'English'
      },
      banner: {
        title: '人力资源 + 人才服务',
        subtitle: 'TALENT SERVICE'
      },
      breadcrumb: {
        home: '首页',
        sep: '>',
        products: '产品服务',
        current: '人力资源 + 人才服务'
      },
      tabs: {
        labor: '劳动关系服务',
        talent: '人才服务',
        manage: '管理咨询服务',
        laborTitle: '劳务外包 / 劳务派遣 / 灵活用工体系',
        talentTitle: '人才招聘 / 人才测评 / 数字化档案管理',
        manageTitle: '人力资源战略管理咨询 / 战略规划咨询 / 集团管理咨询'
      },
      services: {
        laborOutsourcing: {
          title: '劳务外包',
          content: '业务流程外包（BPO）是将部分业务或职能工作委托给专业机构，由其按照客户单位要求组织人员完成。湘楚人力依托多年行业经验，为客户量身定制外包方案，帮助企业降低管理成本、提升运营效率。'
        },
        laborDispatch: {
          title: '劳务派遣',
          content: '劳务派遣是由具备资质的机构与员工签订劳动合同，再派遣至用工单位工作的用工方式。湘楚人力可为客户提供合同签订、员工档案、社保办理、工伤处理等全流程服务，帮助企业实现规范用工与降本增效。'
        },
        flexEmployment: {
          title: '灵活用工体系',
          content: '灵活用工可满足企业在 1 天、1 个月、1 年等不同周期下的用工需求。通过专业第三方服务，企业可有效降低人力成本、提升组织灵活性和抗风险能力。'
        },
        hrStrategy: {
          title: '人力资源战略管理咨询',
          content: '将企业战略目标转化为可落地的人力资源管理要求，提升人力工作的前瞻性、系统性与协同性，为企业人才储备与组织发展提供长期支撑。'
        },
        strategyPlanning: {
          title: '战略规划咨询',
          content: '基于企业内外部环境分析与战略模型工具，帮助企业明确战略定位，建立战略目标、保障体系、实施路径与行动计划，构建完整战略管理体系。'
        },
        groupConsulting: {
          title: '集团管理咨询',
          content: '围绕集团与子分公司的职责分工、权责体系与协同机制进行优化，强化集团统筹能力与子公司执行能力，提升组织运行效率与决策质量。'
        },
        talentRecruit: {
          title: '人才招聘',
          content: '企业可将全部或部分招聘工作外包给湘楚人力。通过一站式招聘流程外包服务（RPO），可有效缩短招聘周期、提升到岗率与岗位匹配度。'
        },
        talentAssess: {
          title: '人才测评',
          content: '依托专业测评模型与工具，从能力、性格、潜力等维度对人才进行科学评估，帮助企业提升选才效率与人岗匹配准确率。'
        },
        archiveManage: {
          title: '数字化档案管理',
          content: '通过标准化、系统化的档案整理与数字化建设，解决档案存储空间不足、管理效率低、查阅不便等问题，提升档案管理规范性与安全性。'
        }
      },
      contact: {
        title: '留下您的联系方式',
        subtitle: '湘楚将尽快与您取得联系',
        typeCompany: '企业',
        typePerson: '个人',
        questionLabel: '咨询问题（必填）',
        nameLabel: '姓名（必填）',
        phoneLabel: '手机号（必填）',
        submit: '预约咨询',
        hotlineTime: '周一至周五 09:30 - 17:00'
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      news: 'News',
      jobs: 'Careers',
      party: 'Party Park',
      overseas: 'Overseas Column'
    },
    lang: {
      switchToEn: 'English',
      switchToZh: '中文'
    },
    header: {
      aboutMenu: {
        title: 'About Xiangchu',
        desc: 'Xiangchu Human Resources Group Co., Ltd. was founded in 2003. After 22 years of dedicated development, we have established business partnerships with hundreds of organizations across dozens of industries, serving more than 50,000 employees every year and providing strong support for clients in standardizing labor relations, reducing labor costs, improving employee skills, and increasing workforce flexibility.',
        intro: 'Company Profile',
        honor: 'Honors & Qualifications',
        team: 'Management Team',
        culture: 'Corporate Culture',
        contact: 'Contact Us'
      }
    },
    newHome: {
      tools: {
        homeShort: 'Home'
      }
    },
    heroBanner: {
      title: 'Dream of Xiangchu',
      slogan: 'Dream Begins · Crafted with Heart · Soul of Hunan · Vision Beyond'
    },
    companyIntro: {
      title: 'Company Introduction',
      desc1:
        'Xiangchu Human Resources Group was founded in 2003. After 22 years of growth, we have built partnerships with hundreds of organizations across dozens of industries.',
      desc2:
        'We serve over 50,000 employees every year, helping clients standardize labor relations, reduce labor costs, improve skills, and increase workforce flexibility.',
      stats: {
        ip: 'IP Rights',
        branches: 'Branches',
        clients: 'Clients',
        employees: 'Employees Served'
      }
    },
    aboutIntro: {
      title: 'Company Profile',
      subTitle: 'SYNOPSIS',
      desc1: 'Xiangchu Human Resources Group is one of the earliest comprehensive HR service enterprises in Hunan. Founded in 2003, by 2025 the group has expanded to more than 50 branches nationwide, serving over 800 clients and more than 300,000 employees, becoming a well-known integrated HR service provider in China.',
      desc2: 'We focus on talent governance and panoramic digital HR R&D. Relying on a nationwide service network and an advanced SaaS platform, we provide one-stop solutions covering consulting and management outsourcing, executive search, HR project outsourcing, and risk protection solutions.'
    },
    aboutHero: {
      title: 'About Xiangchu',
      subtitle: 'ABOUT XIANGCHU',
      breadcrumbHome: 'Home',
      breadcrumbCurrent: 'About Xiangchu',
      anchorIntro: 'Company Profile',
      anchorHonor: 'Honors & Qualifications',
      anchorCulture: 'Corporate Culture',
      anchorTeam: 'Management Team'
    },
    milestoneSection: {
      milestones: {
        '2024': {
          desc: ['Received the Hunan Province Human Resources Service Organization with Significant Employment Promotion Results', 'Hunan Province Listed Company Reserve Resource Pool Member', 'Changsha Tianxin Economic Development Zone Integrity Management Enterprise', 'Xiangtan New Social Sector Demonstration Red Party Building Brand']
        },
        '2023': {
          desc: ['Selected into the third batch of 100 Gold Medal Labor and Personnel Dispute Mediation Organizations nationwide', 'Changsha Human Resources Service Key Enterprise Employment Promotion Demonstration Organization', 'HRoot 2022 Best Human Resources Service Organization', '2022 Hunan Province Human Resources Service High-quality Development Enterprise']
        },
        '2022': {
          desc: ['Xiangtan Red Party Building Brand Demonstration Unit', 'Hunan Province Entrepreneurship-driven Employment Human Resources Service Demonstration Organization', 'Hunan Province Labor and Personnel Dispute Gold Medal Mediation Organization', 'Recognized as a key project in Hunan Province service industry digital infrastructure']
        },
        '2020': {
          desc: ['Received the AAA Enterprise Credit Rating Certificate', 'Expanded service coverage with new branches in Guizhou, Ningxia, and more']
        },
        '2019': {
          desc: ['Honored as one of the Top 10 Construction Labor Enterprises in Xiangtan City', 'Honored as an A-level (Excellent) Unit']
        },
        '2018': {
          desc: ['Founded Xiangchu Human Resources Group Co., Ltd.', 'Launched a new strategic layout and entered a new brand era']
        },
        '2017': {
          desc: ['Founded the Campus Branch of Hunan Xiangchu Human Resources Co., Ltd.']
        },
        '2016': {
          desc: ['Won the Enterprise Culture Silver Award at the First China Cleaning Culture Festival', 'Founded multiple branches in Shaoyang, Yongzhou, and other cities']
        },
        '2015': {
          desc: ['Renamed Hunan Xiangchu Human Resources Co., Ltd.', 'Founded Loudi Branch and Changsha Branch']
        },
        '2014': {
          desc: ['Awarded the national first-class qualification for China cleaning and washing industry']
        },
        '2012': {
          desc: ['Honored as a Famous Labor Dispatch Brand Institution', 'Founded Xiangtan Human Resources Training School']
        },
        '2011': {
          desc: ['Official launch of production outsourcing service projects with comprehensive product upgrades', 'Founded Hunan Xiangchu Environmental Property Management Co., Ltd.']
        },
        '2009': {
          desc: ['Business scale began to take shape with over ten thousand outsourced employees served', 'Founded Hunan Xiangren Network Communication Co., Ltd.']
        },
        '2007': {
          desc: ['Honored as a Labor Security Integrity Enterprise', 'Introduced the core management team and built an elite workforce']
        },
        '2006': {
          desc: ['Service network fully covered Xiangtan City and extended to Changsha and Zhuzhou']
        },
        '2005': {
          desc: ['Honored as an Advanced Re-employment Enterprise']
        },
        '2003': {
          desc: ['Xiangtan Human Resources Service Co., Ltd. was established', 'Founded Hunan Xiangchu Human Resources Co., Ltd.']
        }
      }
    },
    honorSection: {
      title: 'Honors & Qualifications',
      subTitle: 'HONOR',
      tabHonor: 'Corporate Honors',
      tabCert: 'Qualification Certificates',
      honor1: 'Five-Star Party Organization',
      honor2: 'National High-Tech Enterprise',
      honor3: 'Standing Council Member Unit',
      honor4: 'A-Level Labor Law Compliance Unit',
      honor5: 'New-Economy Demonstration Enterprise',
      honor6: 'Best Human Resources Service Organization',
      cert1: 'Labor Dispatch Operation License',
      cert2: 'Human Resources Service License',
      cert3: 'Safety Production License',
      cert4: 'Information Security Management System Certification',
      cert5: 'Quality Service Integrity Unit',
      cert6: 'AAA Enterprise Credit Rating'
    },
    teamSection: {
      title: 'Management Team',
      subTitle: 'TEAM',
      members: {
        m1: { name: 'Ding Chunsong', position: 'CPC Member, Engineer, Senior HR Specialist, Senior Economist', desc: '☞ Secretary of Party Committee, Chairman and President of Xiangchu Human Resources Group.<br/>☞ Extensive experience from government and SOE leadership to private entrepreneurship, with 20 years in HR management.' },
        m2: { name: 'Li Shuangshuang', position: 'Party Committee Member, Vice President of Xiangchu Human Resources Group Co., Ltd.', desc: '☞ CPC Member, Accountant.<br/>☞ Specializes in equity incentives, control-right allocation and capital path planning.' },
        m3: { name: 'Yan Han', position: 'Party Committee Member, Vice President of Xiangchu Human Resources Group Co., Ltd.', desc: '☞ Senior HR Manager, International Certified Public Accountant (ICPA).<br/>☞ Member of the HR and social security expert pool.' },
        m4: { name: 'Ma Ying', position: 'Party Committee Member, Vice President of Xiangchu Human Resources Group Co., Ltd.', desc: '☞ Senior HR Manager and information management expert.<br/>☞ Leads SaaS/HRO integrated platform R&D and project operations.' },
        m5: { name: 'Chu Yaqiong', position: 'Party Committee Member, Vice President of Xiangchu Human Resources Group Co., Ltd.', desc: '☞ National Level-1 Labor Relations Coordinator.<br/>☞ Rich experience in labor relations management.' },
        m6: { name: 'Xiong Guoping', position: 'Deputy Secretary of Party Committee, Chairman of Labor Union', desc: '☞ Extensive experience in workplace safety and related industries.<br/>☞ Proficient in safety regulations and technical standards with strong practical expertise.' },
        m7: { name: 'Jiang Qun', position: 'Party Committee Member, Principal of Xiangtan Human Resources Training School', desc: '☞ Nearly 10 years of experience in the HR industry.<br/>☞ Participated in multiple HR standardization and performance system projects.' },
        m8: { name: 'Zhu Aiping', position: 'Marketing Director, Xiangchu Human Resources Group', desc: '☞ Skilled in marketing, customer service and labor dispatch.<br/>☞ Extensive experience in marketing and enterprise management.' },
        m9: { name: 'Huang Genrong', position: 'Specially Appointed Expert, Hunan Xiangchu Human Resources Research Institute Co., Ltd.', desc: '☞ Senior Economist, Senior Political Engineer.<br/>☞ 36 years of HR management and consulting experience.' },
        m10: { name: 'Shen Yaping', position: 'Legal Counsel, Xiangchu Human Resources Group', desc: '☞ 32 years of legal practice with review of tens of thousands of contracts.<br/>☞ Handled over 10,000 legal consultations.' }
      }
    },
    presidentMessage: {
      title: 'President Message',
      subTitle: 'MESSAGE',
      slogan: 'With the vision of "covering the nation, reaching the world, and becoming a leading one-stop human resources total solution provider in China"',
      p1: 'History moves forward through changing times, and dreams come true through perseverance. Twenty-two years of trials have forged unwavering belief; twenty-two years of progress have written a new chapter through shared dedication.',
      p2: 'Every step of Xiangchu’s growth comes from the hard work of every Xiangchu member, as well as care and support from all sectors of society, encouragement from experts, and trust from our clients.',
      p3: 'Looking at the bigger picture and into the future, Xiangchu Human Resources embraces a brighter prospect and will continue to write a new chapter in the new era.'
    },
    serviceSection: {
      menu1Text1: 'HR +',
      menu1Text2: 'Labor Relations Service',
      menu1Desc: 'Lower labor costs and maximize efficiency',
      menu2Text1: 'HR +',
      menu2Text2: 'Talent Service',
      menu2Desc: 'Improve overall quality and sustainable competitiveness',
      menu3Text1: 'HR +',
      menu3Text2: 'Management Consulting',
      menu3Desc: 'Deliver quality service and stronger management control',
      menu4Text1: 'HR +',
      menu4Text2: 'Digital Cloud Service',
      menu4Desc: 'Enable SME management transformation in Internet+ era',
      g0c0Title: 'Labor Outsourcing',
      g0c0Desc: 'Handle entrusted personnel affairs and labor-related consulting.',
      g0c1Title: 'Labor Dispatch',
      g0c1Desc: 'Qualified agencies dispatch staff to support flexible workforce needs.',
      g0c2Title: 'Flexible Employment System',
      g0c2Desc: 'Support labor scenarios across day/month/year cycles.',
      g1c0Title: 'Talent Recruitment',
      g1c0Desc: 'Outsource hiring demands to improve efficiency and onboarding speed.',
      g1c1Title: 'Talent Assessment',
      g1c1Desc: 'Use objective methods to improve job-match accuracy.',
      g1c2Title: 'Digital Archive Management',
      g1c2Desc: 'Standardized and efficient archive management with less storage burden.',
      g2c0Title: 'HR Planning',
      g2c0Desc: 'Turn strategy into HR needs with stronger forward-looking management.',
      g2c1Title: 'Strategic Planning Consulting',
      g2c1Desc: 'Identify internal/external factors and define execution path.',
      g2c2Title: 'Industry-Intelligence-Finance Innovation Platform',
      g2c2Desc: 'Clarify responsibilities and improve organizational collaboration.',
      g3c0Title: 'Digital Cloud Service',
      g3c0Desc: 'Build digital HR systems for efficient one-stop online operations.'
    },
    enterpriseStrength: {
      mainTitle: 'STRENGTH',
      subTitle: 'Enterprise Strength',
      tabCities: 'Covered Cities',
      tabBranches: 'Subsidiaries & Branches',
      c1Title: 'Hunan Xiangchu Human Resources Co., Ltd.',
      c1Desc: 'Founded in 2003, one of the earliest wholly-owned subsidiaries serving Hunan clients.',
      c2Title: 'Hunan Xiangchu HR Research Institute',
      c2Desc: 'A unique HR institute in Hunan providing continuous professional research support.',
      c3Title: 'Hunan Dingdian Information Technology Co., Ltd.',
      c3Desc: 'Founded in 2018, focused on digital transformation for SMEs.',
      c4Title: 'Hunan Xiangchu Environmental Property Management Co., Ltd.',
      c4Desc: 'Provides sanitation, landscaping, and integrated property services.',
      c5Title: 'Hunan Xiangchu Logistics Co., Ltd.',
      c5Desc: 'Founded in 2016, centered on HR services plus outsourcing and consulting.',
      c6Title: 'Hunan Xiangren Engineering Co., Ltd.',
      c6Desc: 'Founded in 2009 with mature engineering service capabilities.',
      c7Title: 'Xiangtan Human Resources Training School',
      c7Desc: 'Provides vocational and special-operation training qualifications.',
      c8Title: 'Xiangxiang Human Resources Service Co., Ltd.',
      c8Desc: 'Founded in 2005 with a service philosophy focused on talent and enterprise value.',
      c9Title: 'Changsha Hemi Creative Communication Co., Ltd.',
      c9Desc: 'Provides integrated brand planning, design, PR and digital marketing.',
      c10Title: 'Hunan Zhile Technology Co., Ltd.',
      c10Desc: 'Founded in 2022 with seed investment from the group.',
      c11Title: 'Hunan Xiangchu Shenghe Enterprise Consulting Co., Ltd.',
      c11Desc: 'Focused on enterprise services and full-ecosystem value.',
      c12Title: 'Hunan Xiangchu Youhu Health Management Co., Ltd.',
      c12Desc: 'One-stop smart companion care solutions for medical and home scenarios.'
    },
    cooperation: {
      mainTitle: 'COOPERATION',
      subTitle: 'Partner Brands',
      content:
        'Xiangchu provides comprehensive and professional services to help clients separate non-core roles or processes. Through professional personnel management and standardized operations, we simplify hiring procedures and reduce management costs. With advanced IT and systems support, we reduce employment risks and improve management efficiency, enabling clients to focus on high-value core business.'
    },
    qysm: {
      item1Title: 'Mission:',
      item1Slogan: 'Empower business success and employee growth',
      item2Title: 'Vision:',
      item2Slogan:
        'Serve nationwide and beyond; become a leading one-stop human capital solution provider in China',
      item3Title: 'Corporate Code of Conduct:',
      item3Slogan: 'Customer first, quality first, integrity and compliance, mutual achievement',
      item4Title: 'Employee Code of Conduct:',
      item4Slogan: 'Collaborate to create value',
      item5Title: 'Business Philosophy:',
      item5Slogan: 'Make service value perceptible, measurable, and visible',
      cultureAlt: 'Corporate Culture'
    },
    culture: {
      title: 'Corporate Culture',
      missionTitle: 'Mission',
      missionDesc: 'Empower business success and employee growth',
      visionTitle: 'Vision',
      visionDesc: 'Serve nationwide and beyond; become a leading one-stop human capital solution provider in China',
      codeTitle: 'Corporate Code of Conduct',
      codeDesc: 'Customer first, quality first, integrity and compliance, mutual achievement',
      staffCodeTitle: 'Employee Code of Conduct',
      staffCodeDesc: 'Collaborate to create value',
      philosophyTitle: 'Business Philosophy',
      philosophyDesc: 'Make service value perceptible, measurable, and visible'
    },
    contactUs: {
      heroTitle: 'Contact Us',
      heroSubtitle: 'CONTACT US',
      breadcrumbHome: 'Home',
      breadcrumbCurrent: 'Contact Us',
      anchorMap: 'Xiangchu Map',
      anchorCompany: 'Subsidiaries',
      anchorMessage: 'Online Message',
      poetry1: 'Every soil and tree pioneers, every verse praises the land,',
      poetry2: 'Years of dedication and hard work,',
      poetry3: 'Have blossomed into prosperity.',
      manager: 'Manager: ',
      phone: 'Phone: ',
      mapTitle: 'Xiangchu Map',
      companies: {
        c1Name: 'Hunan Xiangchu Human Resources Co., Ltd.',
        c1Desc: 'Founded in 2003, it is one of the earliest wholly-owned subsidiaries of Xiangchu Group. It has established branches across Hunan and serves over 30,000 employees annually in many industries.',
        c2Name: 'Hunan Xiangchu Human Resources Research Institute Co., Ltd.',
        c2Desc: 'A provincial-level HR research institution focused on policy, organization, HR management, culture, industry studies, assessment, headhunting and training, serving governments and enterprises.',
        c3Name: 'Hunan Dingdian Information Technology Co., Ltd.',
        c3Desc: 'Established in 2018, dedicated to SME digital transformation with consulting, development and system operations, helping businesses reduce costs and improve efficiency.',
        c4Name: 'Hunan Xiangchu Environmental Property Management Co., Ltd.',
        c4Desc: 'Founded in 2011 with RMB 12 million registered capital, focused on cleaning, landscaping, property management and water pollution control.',
        c5Name: 'Hunan Xiangchu Logistics Co., Ltd.',
        c5Desc: 'Founded in 2016 with RMB 5 million capital, providing labor outsourcing, logistics project services, management consulting, tailored training and logistics information services.',
        c6Name: 'Hunan Xiangren Engineering Co., Ltd.',
        c6Desc: 'Formerly Hunan Xiangren Network Communications Co., Ltd., founded in 2009 with RMB 8 million capital and Class-III qualification for electric power engineering contracting.',
        c7Name: 'Xiangtan Human Resources Training School',
        c7Desc: 'Provides multi-skill vocational and special-operation training, delivering lifecycle-oriented training and value-added services for workers.',
        c8Name: 'Xiangxiang Human Resources Service Co., Ltd.',
        c8Desc: 'Founded in 2005, committed to creating opportunities for talent, resources for enterprises and value for society, integrating training, service and management.',
        c9Name: 'Changsha Hemi Creative Culture Communication Co., Ltd.',
        c9Desc: 'Focused on brand planning, creative design, PR consulting and digital marketing, with systematic brand diagnosis, integration, design and promotion services.',
        c10Name: 'Hunan Zhile Technology Co., Ltd.',
        c10Desc: 'Established in 2022, operating an integrated social platform for students in job seeking, shopping, social networking, entrepreneurship and test prep.',
        c11Name: 'Hunan Xiangchu Shenghe Enterprise Consulting Service Co., Ltd.',
        c11Desc: 'Focused on enterprise services, including business registration, intellectual property, government funding and project applications.',
        c12Name: 'Hunan Xiangchu Youhu Health Management Co., Ltd.',
        c12Desc: 'A high-quality one-stop smart care provider for hospital companionship, in-hospital care, home care and elder companionship.'
      }
    },
    footer: {
      followUs: 'Follow Us',
      recruit: 'Join Us',
      socialRecruit: 'Social Recruitment',
      talentPool: 'Xiangchu Talent Pool',
      contact: 'Contact Us',
      map: 'Xiangchu Map',
      branch: 'Six Subsidiaries & Branches',
      legal: 'Legal Information',
      agreement: 'Service Agreement',
      privacy: 'Privacy Policy',
      name: 'Name:',
      phone: 'Contact:',
      demandPlaceholder: 'Leave your needs and we will provide professional solutions',
      submit: 'Submit Now',
      validateName: 'Please enter your name',
      validatePhone: 'Please enter your contact information',
      validateRemark: 'Please enter your request details!',
      submitSuccess: 'Submitted successfully! We will respond within 1-3 business days.',
      submitError: 'Submission failed, please try again later'
    },
    siteFooter: {
      followUs: 'Follow Us',
      recruit: 'Careers',
      socialRecruit: 'Social Recruitment',
      talentPool: 'Xiangchu Talent Pool',
      contact: 'Contact Us',
      map: 'Xiangchu Map',
      branch: 'Subsidiaries',
      legal: 'Legal Information',
      agreement: 'Service Agreement',
      privacy: 'Privacy Policy',
      name: 'Name:',
      contactEmail: 'Contact (Email):',
      demandPlaceholder: 'Leave your needs and we will provide professional solutions',
      submit: 'Submit Now',
      validateName: 'Please enter your name',
      validatePhone: 'Please enter your contact email',
      validateRemark: 'Please enter your request details!',
      submitSuccess: 'Submitted successfully! We will respond within 1-3 business days.',
      submitError: 'Submission failed, please try again later'
    },
    overseasColumn: {
      hero: {
        title: 'Full-Cycle Global HR Solutions',
        desc1: 'From market testing to long-term expansion, we streamline overseas employment, ensure compliance and efficiency,',
        desc2: 'and accelerate successful global execution.',
        cta: 'Start Now · Get Your Tailored Plan'
      },
      common: {
        painPoints: 'Pain Points',
        solution: 'Solutions',
        value: 'Customer Value',
        learnMore: 'Learn More'
      },
      scenario1: {
        title: 'Scenario 1: Market Testing, Fast Launch',
        subtitle: 'Start Compliantly Without a Local Entity',
        pain1: 'Company setup . is slow and costly, increasing validation and trial expenses.',
        pain2: 'Employment workflows are complex and time-consuming, often blocked by approvals.',
        solutionTitle: 'Employer of Record (EOR) + Expert Mobility',
        solution1: '"Zero-entity" landing: no local entity required; compliant onboarding in 1-4 weeks with integrated finance and management support.',
        solution2: 'Expert mobility services: full-process support for visas, housing, tax and cross-regional deployment.',
        value: 'Lower startup cost, shorten market validation cycles, and reduce employment risks.'
      },
      scenario2: {
        title: 'Scenario 2: Business Expansion, Team Building',
        subtitle: 'Solve Hiring and Payroll Challenges',
        pain1: 'Local talent supply cannot keep pace with business expansion, causing long hiring cycles.',
        pain2: 'Cross-border payroll, tax and benefits are complex with high compliance difficulty.',
        solutionTitle: 'Recruitment Process Outsourcing (RPO) + Payroll Process Outsourcing (PPO)',
        solution1: '"Omni-channel" hiring: leverage localized networks, digital platforms and campus channels for accurate matching.',
        solution2: '"Light-operation" payroll: end-to-end payroll design, tax filing, social insurance, payment and reporting with full compliance.',
        value: 'Break regional talent limits, improve workforce efficiency, and accelerate team scaling.'
      },
      scenario3: {
        title: 'Scenario 3: Project Delivery, Structured Workforce Management',
        subtitle: 'Ensure Stable Operation of Large-Scale Teams',
        pain1: 'Large projects often require hundreds of multinational workers, involving visa, housing, transport, security and more.',
        pain2: 'High mobility and coordination needs can cause delays due to cultural gaps and inconsistent execution.',
        solutionTitle: 'Integrated Blue-Collar Workforce Solution',
        solution1: '"Resource-first" coordination and management: recruitment, visa handling, entry control, dormitory, transport, payroll and safety compliance.',
        solution2: '"On-site steward" service: dedicated teams for communication, cultural adaptation and incident response to improve stability.',
        value: 'Ensure continuous labor supply, strengthen on-site execution, and improve cross-cultural efficiency and retention.'
      },
      scenario4: {
        title: 'Scenario 4: Long-Term Deepening, Systematic Operations',
        subtitle: 'Mitigate Systemic Risk and Improve Quality & Efficiency',
        pain1: 'Lack of local labor-law and management experience creates hidden compliance risks.',
        pain2: 'Limited overseas team capability and cross-cultural collaboration hinder long-term growth.',
        solutionTitle: 'HR Consulting + Capability Training',
        solution1: '"Compliance advisory": policy updates, handbook customization, employer branding, and internal compliance review support.',
        solution2: '"Cultural enablement": cross-cultural communication and leadership training to build global management capability.',
        value: 'Proactively avoid systemic risk, strengthen execution and cohesion, and support sustainable growth.'
      },
      cta: {
        title: 'Global Cross-Border HR Services, From Launch to Deep Expansion',
        desc: 'Covering market testing, structured project delivery and systematic operations for every stage of overseas growth.',
        button: 'Start Now · Get Your Tailored Plan'
      }
    },
    laborRelations: {
      nav: {
        logoAlt: 'Xiangchu Human Resources Group',
        home: 'Home',
        about: 'About',
        products: 'Products',
        news: 'News',
        jobs: 'Careers',
        party: 'Party Park',
        en: 'English'
      },
      banner: {
        title: 'Human Resources + Talent Service',
        subtitle: 'TALENT SERVICE'
      },
      breadcrumb: {
        home: 'Home',
        sep: '>',
        products: 'Products',
        current: 'Human Resources + Talent Service'
      },
      tabs: {
        labor: 'Labor Relations Service',
        talent: 'Talent Service',
        manage: 'Management Consulting Service',
        laborTitle: 'Labor Outsourcing / Labor Dispatch / Flexible Employment System',
        talentTitle: 'Talent Recruitment / Talent Assessment / Digital Archive Management',
        manageTitle: 'HR Strategic Management Consulting / Strategic Planning Consulting / Group Management Consulting'
      },
      services: {
        laborOutsourcing: {
          title: 'Labor Outsourcing',
          content: 'Business Process Outsourcing (BPO) refers to the practice of contracting certain business or functional work to a related organization, which arranges staff to complete the work according to the requirements of the client enterprise or government department. As a professional HR company, Xiangchu Human Resources Group has accumulated rich experience in HR outsourcing services and has become a leading force in the regional outsourcing market. For businesses or government departments requiring such services, we tailor professional outsourcing solutions from a professional perspective, introduce market competition, and provide the highest-quality services for both the outsourcing party and client organizations.'
        },
        laborDispatch: {
          title: 'Labor Dispatch',
          content: 'Labor dispatch, also known as talent dispatch or labor leasing, refers to a staffing model where a labor dispatch agency signs labor contracts with dispatched employees, sends them to work for client enterprises, accepts the client’s management, and receives service fees from the client. The client pays the dispatch agency, and the agency pays wages to the workers. In this model, Xiangchu Human Resources Group acts as the legal employer of the staff, while the client signs a dispatch agreement with Xiangchu. The client manages the work, and Xiangchu handles personnel management such as employee records, contract negotiation and signing, contract administration, staffing, skills training, social insurance, and work injury handling, enabling clients to achieve maximum HR efficiency without increasing headcount or labor costs.'
        },
        flexEmployment: {
          title: 'Flexible Employment System',
          content: 'Flexible employment means outsourcing short-term or irregular staffing needs to a professional third-party agency, meeting demand across 1-day, 1-month, or 1-year cycles. To address rising HR costs, Xiangchu offers flexible employment services to reduce labor costs, increase organizational flexibility, and inject innovation, helping enterprises gain stronger competitive advantages.'
        },
        hrStrategy: {
          title: 'HR Industry Strategic Management Consulting',
          content: 'Xiangchu transforms HR planning into concrete HR management requirements, improving foresight, systematization, and comprehensiveness in HR work. It enables strategic talent reserves and development, aligns HR with business development, improves HR efficiency, and provides improvement directions and consistent standards for HR management activities.'
        },
        strategyPlanning: {
          title: 'Strategic Planning Consulting',
          content: 'By applying strategic planning framework models and other tools, we help enterprises clarify their internal and external environment and strategic positioning. On this basis, we progressively formulate overall plans, assurance systems, strategic measures, and action plans, building a complete strategic management system.'
        },
        groupConsulting: {
          title: 'Group Management Consulting',
          content: 'Enterprises can reasonably structure the management and operating framework between the group company and its subsidiaries, clearly defining departmental and role responsibilities. This aligns authority and division of labor across the group and subsidiaries, fully leveraging command, coordination, service, and supervision functions at the group level while strengthening strategic execution, business operations, and production support at the subsidiary level, resulting in clear workflows, efficient operations, and faster decision-making.'
        },
        talentRecruit: {
          title: 'Talent Recruitment',
          content: 'Enterprises can outsource all or part of their recruitment needs to Xiangchu, which functions like an internal recruitment department. To address hiring difficulties, Xiangchu offers one-stop Recruitment Process Outsourcing (RPO) services that improve recruitment quality, shorten vacancy filling time, and enhance the overall recruitment process.'
        },
        talentAssess: {
          title: 'Talent Assessment',
          content: 'Using Xiangchu’s professional talent assessment system, enterprises can scientifically identify talent and build systematic assessment solutions that improve evaluation efficiency and accuracy. Leveraging Xiangchu’s software capabilities, we provide full-process talent assessment solutions driven by data.'
        },
        archiveManage: {
          title: 'Digital Archive Management',
          content: 'We solve problems related to archive storage space, security, and operational efficiency. Through standardized, normalized, and systematic archive organization and consulting services, we improve the orderly management and completeness of archives. Based on client industry characteristics and needs, we create customized digital archive systems to improve management efficiency.'
        }
      },
      contact: {
        title: 'Leave Your Contact Information',
        subtitle: 'Xiangchu will contact you as soon as possible',
        typeCompany: 'Enterprise',
        typePerson: 'Individual',
        questionLabel: 'Consultation Question (Required)',
        nameLabel: 'Name (Required)',
        phoneLabel: 'Mobile Number (Required)',
        submit: 'Book Consultation',
        hotlineTime: 'Mon - Fri 09:30 - 17:00'
      }
    }
  }
}
